// extracted by mini-css-extract-plugin
export default {"header":"OO-z","isActive":"PO-z"};